import { toast } from "react-toastify";
import { ApiService } from "../api";
import { Device } from "./";
import { Call } from "./Call";

/**
 * Functions for fetching opportunites.
 */
export class DialerService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	/**
	 * Find devices for the current user
	 *
	 */
	public async findDevices(): Promise<Device[]> {
		const deviceData = await this.apiService.get(`/api/v1/dialer/devices`);
		const devices = await deviceData.json();

		return Device.fromJsonArray(devices);
	}

	public async call(
		leadId: string,
		phoneNumber: string,
	): Promise<Call | void> {
		const callData = await this.apiService.get(
			`/api/v1/dialer/call/${leadId}?number=${phoneNumber}`,
		);

		const call = await callData.json();
		if (callData.status === 200) {
			return Call.fromJson(call);
		} else {
			toast.error(call.message);
		}
	}

	public async logCall(
		leadId: string,
		callResult: string,
		callDuration: number,
		description: string,
		callId: number,
	): Promise<string> {
		const messageData = await this.apiService.post(
			`/api/v1/dialer/call/${leadId}/log`,
			{
				description,
				calldisposition: callResult,
				duration: callDuration,
				call_id: callId,
			},
		);

		const message = await messageData.json();

		return message.message;
	}
}
